import { Injectable } from '@angular/core';
import { PaymentActions } from '@nibtravel/shared/data-access/payment';
import {
  HttpAlreadyPurchaseError,
  HttpErrorMessageCode,
  HttpNoConnectionError,
  HttpNotFoundError,
  HttpPaymentThreeDSRequired,
  HttpUnprocessableEntityError,
  NibTravelHttpError,
} from '@nibtravel/shared/util/models';

import { IPurchaseResponse } from '../models/purchase.model';

@Injectable()
export class ErrorHelper {
  errorAction(
    error: NibTravelHttpError
  ): PaymentActions.SetErrors | PaymentActions.Update {
    if (error instanceof HttpPaymentThreeDSRequired) {
      const data: IPurchaseResponse = error.response && error.response.error;
      if (data.threeDSResponseInfo && data.cardToken && data.paymentIds) {
        return new PaymentActions.Update(
          data.threeDSResponseInfo,
          data.cardToken,
          data.paymentIds
        );
      }
    }

    if (error instanceof HttpUnprocessableEntityError) {
      const errorData = error.validation.errors && error.validation.errors[0];
      return new PaymentActions.SetErrors(errorData?.code, errorData?.message);
    }

    if (error instanceof HttpAlreadyPurchaseError) {
      return new PaymentActions.SetErrors(
        HttpErrorMessageCode.AlreadyPurchased
      );
    }

    if (error instanceof HttpNoConnectionError) {
      return new PaymentActions.SetErrors(HttpErrorMessageCode.NoInternet);
    }

    if (error instanceof HttpNotFoundError) {
      return new PaymentActions.SetErrors(HttpErrorMessageCode.NotFound);
    }

    return new PaymentActions.SetErrors(HttpErrorMessageCode.ServerError);
  }
}
